module.exports = __webpack_public_path__ + "img/official.b9bb8478.svg";